<template>
  <div>
    <v-modal short @close="$emit('close')">
      <template :slot="THREAD_MODAL_HASH.SUBSCRIBERS">
        <div
          v-if="isLoading"
          class="d-flex justify-content-center text-muted mt-5 pt-5"
        >
          <v-loader />
        </div>
        <div v-else class="subscribers__container d-flex flex-column">
          <action-header>
            {{ $t("components.modals.pageSubscribersModal.memberTitle") }}
          </action-header>
          <action-body>
            <member-row
              v-for="(subscriber, index) in subscribers"
              :key="index"
              :member="subscriber"
            />
          </action-body>

          <infinite-pagination
            v-if="isAuthenticated"
            list-key="subscribers"
            :path="`/pages/${pageId}/subscribers`"
            :init-page="1"
            @loaded="handleLoaded"
          />
        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

import ActionHeader from "@/components/modals/shared/ActionHeader"
import ActionBody from "@/components/modals/shared/ActionBody"
import MemberRow from "@/components/modals/shared/MemberRow"
import { THREAD_MODAL_HASH } from "@/lib/messages-utils"

import InfinitePagination from "@/components/InfinitePagination"

export default {
  components: {
    ActionHeader,
    ActionBody,
    MemberRow,
    InfinitePagination
  },

  props: {
    pageId: { type: [Number, String], required: true }
  },

  data() {
    return {
      isLoading: false,
      subscribers: [],
      initPage: 1,
      THREAD_MODAL_HASH
    }
  },

  methods: {
    ...mapGetters("auth", ["isAuthenticated"]),

    handleLoaded({ list }) {
      this.subscribers = [...this.subscribers, ...list]
    }
  }
}
</script>

<style lang="scss" scoped>
.subscribers__container {
  .name {
    font-weight: 600;
  }
}
</style>
